import { makeAutoObservable } from "mobx";
import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";
import { EntityStatesHistoryStore } from "./EntityStatesHistory/EntityStatesHistoryStore";
import { EntityAttsHistoryStore } from "./EntityAttsHistory";
import { EntityAuditStore } from "./EntityAudit/EntityAuditStore";
import { ZAuditEvent } from "./EntityAudit/ZEntityAudit";

export class EntityHistoryStore {
  constructor(
    public readonly objectId: ZUid,
    public readonly entityId: ZUid,
    public readonly stateNames: Record<ZUid, string>,
    public readonly attributesMap: Record<ZUid, ZAttribute>,
    public readonly attrTypesMap: Record<number, string>,
    public readonly curStateName: string,
    public readonly entityName: string,
    public readonly onAuditEvent: (event: ZAuditEvent) => void,
    public readonly auditStore: EntityAuditStore,
  ) {
    makeAutoObservable(this);
  }

  statesStore = new EntityStatesHistoryStore(this.entityId, this.stateNames);

  attsStore = new EntityAttsHistoryStore(
    this.objectId,
    this.entityId,
    this.attributesMap,
    this.attrTypesMap,
  );
}
